import { Injectable } from "@angular/core";
import { LogoutConfigurationService } from "../configuration/auth/logout/logout-configuration.service";
import { EndSessionService } from "./end-session.service";
import { Router } from "@angular/router";
import { AuthStorageService } from "./auth-storage.service";
import { AuthModule } from "./auth.module";
import { ReleaseLicenseService } from "../license/release-license.service";
import { ReleaseLicenseConfigurationService } from "../configuration/auth/logout/release-license/release-license-configuration.service";
import { CloudUserStorageService } from "../user/cloud-user-storage.service";
import { UserInfoStorageService } from "../user-info/user-info-storage.service";
import { CloudIsGovCloudStorageService } from "../cloud/cloud-is-gov-cloud-storage.service";
import { WebApiService } from "../web-api/web-api.service";

@Injectable({
  providedIn: AuthModule,
})
export class LogoutService {
  get returnTo() {
    return this.logoutConfigurationService.returnTo;
  }

  get endSessionEnabled() {
    return this.endSessionService.enabled;
  }

  get releaseLicenseEnabled() {
    return this.releaseLicenseConfiguration.enabled;
  }

  get currentUser() {
    return this.userStorageService.currentUser;
  }

  get releaseLicenseConfiguration() {
    return this.releaseLicenseConfigurationService.configuration;
  }

  constructor(
    private logoutConfigurationService: LogoutConfigurationService,
    private authStorageService: AuthStorageService,
    private endSessionService: EndSessionService,
    private router: Router,
    private releaseLicenseService: ReleaseLicenseService,
    private releaseLicenseConfigurationService: ReleaseLicenseConfigurationService,
    private userStorageService: CloudUserStorageService,
    private userInfoStorageService: UserInfoStorageService,
    private cloudIsGovCloudService: CloudIsGovCloudStorageService,
    private webApiService: WebApiService
  ) {}

  logout(): Promise<boolean> {
    this.gatewayLogout().subscribe();

    this.clearCurrentUser();
    this.clearUserInfo();
    this.clearIsGovCloud();
    if (this.releaseLicenseEnabled) {
      return this.releaseLicense().then(() => {
        this.clearAuthData();
        if (this.endSessionEnabled) {
          this.endSession();
          return Promise.resolve(true);
        } else {
          return this.navigateToReturnTo();
        }
      });
    } else {
      this.clearAuthData();
      if (this.endSessionEnabled) {
        this.endSession();
        return Promise.resolve(true);
      } else {
        return this.navigateToReturnTo();
      }
    }
  }

  gatewayLogout() {
    return this.webApiService.get(`/identity/logout`, { addInstanceIdHeader: false, useDefaultConfiguration: true });
  }

  releaseLicense() {
    return this.releaseLicenseService.releaseLicense();
  }

  clearCurrentUser() {
    return this.userStorageService.clear();
  }

  clearUserInfo() {
    return this.userInfoStorageService.clear();
  }

  clearIsGovCloud() {
    this.cloudIsGovCloudService.clearCloudIsGovCloud();
  }

  clearAuthData() {
    return this.authStorageService.clearAll();
  }

  clearCookies() {}

  endSession() {
    return this.endSessionService.endSession();
  }

  navigateToReturnTo() {
    return this.router.navigateByUrl(this.returnTo);
  }
}
